import { ViteReactSSG } from 'vite-react-ssg';
import routes from './routes';
import './index.css';

// vite-react-ssg renders the app and automatically wraps the tree in
// HelmetProvider, so the existing useSEO/Helmet calls contribute to the
// statically-rendered <head> for each prerendered route.
export const createRoot = ViteReactSSG({ routes });
